import { type Threshold } from '../../../../../core/types/threshold-types.js';
import { getValidColor } from '../../../utils/getValidColor.js';
import { getThresholdColor } from '../utils/get-threshold-color.js';

export const getThresholds = (
  inputValue: string | number,
  inputColor: string | undefined,
  thresholds: Threshold[] | undefined,
  defaultColor: string,
): string => {
  const hasThresholds = thresholds && thresholds.length > 0;
  const calculatedColor = hasThresholds
    ? getThresholdColor(inputValue, thresholds) ?? inputColor
    : inputColor;

  return getValidColor(calculatedColor, defaultColor);
};
